export default __webpack_public_path__ + "static/media/hand-raised.bd9cbe9c.svg";